<template lang="pug">
    tr

        // User Full Name
        td {{ item.fullName }}

        // User Email
        td {{ item.email }}

        // Business Name
        td(v-if="isAdmin")
            span(v-if="item.business && item.business.name") {{ item.business.name }}

        // Phone
        td(v-if="item.phone && isChampion") {{ item.phone }}

        // Trial period
        td(v-if="isAdmin")
            div(v-if="item.subscription && item.statusValue === 'trial'")
                div.periodLabel stripe
                span {{ item.createdAt | formattedDate }}
                span {{ ` - ` }}
                span {{ item.subscription.trialPeriodEndedAt | formattedDate }}

            div(v-if="!item.subscription && item.availableUntil && item.statusValue === 'trial'")
                div.periodLabel default
                span {{ item.createdAt | formattedDate }}
                span {{ ` - ` }}
                span {{ item.availableUntil | formattedDate }}

        // Status
        td
            user-status(:status="item.statusValue")

        // Coupon used
        td(v-if="isAdmin") {{ item.subscription ? item.subscription.coupon : '' }}
        // td(v-if="isAdmin") {{ item.status }}

        // City
        td(v-if="isChampion") {{ item.city }}

        // State
        td(v-if="isChampion") {{ item.state }}

        // Country
        td(v-if="isChampion") {{ item.country }}

        // Department
        td(v-if="isChampion && showDepartment") {{ item.department }}

        // TODO: Uncomment when need custom fields
        //td(
        //    v-if="item.additionalInformation && item.additionalInformation.length && isChampion"
        //    v-for="value in customColumn"
        //) {{ value }}

        //td(v-if="isChampion" v-for="(item, index) in fields" :key="index") &nbsp;

        // Actions
        td.actions.text-xs-right(class="justify-center px-0 actions")

            // User statistics button
            button-component.statisticsView(:action="statisticsView" color="primary" icon="insert_chart")

            // Edit user button
            button-component.edit(:action="edit" color="primary" icon="edit")

            // Delete user button
            button-component.delete(:action="remove" color="primary" icon="delete")

            button-component.edit(:action="change" color="primary" icon="repeat")
</template>

<script>
    import VueTypes from 'vue-types';
    import UserStatus from './UserStatus';
    import ButtonIcon from '~components/ButtonIcon';
    import formattedDate from '~filters/FormattedDate';
    import phoneNumber from '~filters/Phone';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        components: {
            UserStatus,
            ButtonComponent: ButtonIcon
        },
        filters: {
            phoneNumber,
            formattedDate
        },
        props: {
            item: VueTypes.object.def({}),
            customFields: VueTypes.array.def([])
        },
        computed: {
            ...mapGetters('auth', ['isChampion', 'isAdmin', 'showDepartment']),
            ...mapGetters('document', ['fields']),

            customColumn() {
                if (this.customFields[0] && !this.customFields[0].id)
                    return ['', ''];

                let customValues = [];
                this.customFields.forEach(field => {
                    const currentField = this.item.additionalInformation.find(
                        item => item.field.id === field.id
                    );
                    customValues.push(currentField.value);
                });

                return customValues;
            }
        },
        methods: {
            ...mapActions('users', ['deleteAccount', 'changeBusiness']),
            /**
             * Edit business
             */
            edit() {
                this.$router.push({
                    name: 'dashboard.users.edit',
                    params: { id: this.item.id }
                });
            },
            /**
             * Edit business
             */
            statisticsView() {
                this.$router.push({
                    name: 'dashboard.statistics.by.user',
                    params: { id: this.item.id }
                });
            },

            /**
             * Delete business.
             * @returns {Promise<void>}
             */
            async remove() {
                const resp = await this.deleteAccount(this.item.id);

                if (resp) {
                    if (
                        this.$router.currentRoute.name ===
                        'dashboard.users.by.business'
                    ) {
                        this.$router.go(this.$router.currentRoute);
                    } else {
                        this.$emit('removed', this.item.id);
                    }
                }
            },

            /**
             * Change business.
             * @returns {Promise<void>}
             */
            async change() {
                const resp = await this.changeBusiness(this.item.id);

                if (resp) {
                    if (
                        this.$router.currentRoute.name ===
                        'dashboard.users.by.business'
                    ) {
                        this.$router.go(this.$router.currentRoute);
                    } else {
                        this.$emit('removed', this.item.id);
                    }
                }
            }
        }
    };
</script>

<style lang="stylus" scoped>
    .actions
        min-width: 115px

    .periodLabel
        text-transform: uppercase
        font-size: 10px
</style>
